import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import {
  selectStrategicInitiativesOfferingOptions,
  selectStrategicInitiativesSelectedOffering,
} from '../selectors'
import { offeringSelected } from '../strategicInitiativesSlice'

export const useStrategicInitiativesOffering = () => {
  const dispatch = useAppDispatch()
  const offerings = useSelector(selectStrategicInitiativesOfferingOptions)
  const offering = useSelector(selectStrategicInitiativesSelectedOffering)

  const setOffering = useCallback(
    (value: string) => {
      dispatch(offeringSelected(value))
    },
    [dispatch]
  )

  return { offering, setOffering, offerings }
}
